(function () {
  function initReels(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;

    var slides = Array.from(track.querySelectorAll('[data-slide]'));
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var activeCard = null;

    function pauseCard(card) {
      var video = card.querySelector('[data-video]');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      card.classList.remove('is-playing');
    }

    function playCard(card) {
      if (activeCard && activeCard !== card) {
        pauseCard(activeCard);
      }
      var video = card.querySelector('[data-video]');
      if (!video) return;
      card.classList.add('is-playing');
      video.muted = false;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          video.muted = true;
          video.play().catch(function () {});
        });
      }
      activeCard = card;
    }

    slides.forEach(function (slide) {
      var card = slide.querySelector('[data-card]');
      var toggle = slide.querySelector('[data-toggle]');
      var productTag = slide.querySelector('[data-product-tag]');

      if (!card) return;

      function handleToggle(event) {
        event.stopPropagation();
        if (card.classList.contains('is-playing')) {
          pauseCard(card);
          if (activeCard === card) activeCard = null;
        } else {
          playCard(card);
        }
      }

      if (toggle) {
        toggle.addEventListener('click', handleToggle);
      } else {
        card.addEventListener('click', handleToggle);
      }

      if (productTag) {
        productTag.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
    });

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var max = track.scrollWidth - track.clientWidth;
      prevBtn.hidden = track.scrollLeft <= 2;
      nextBtn.hidden = track.scrollLeft >= max - 2;
    }

    function scrollByAmount(direction) {
      var slideWidth = slides.length ? slides[0].getBoundingClientRect().width + 10 : 300;
      track.scrollBy({ left: direction * slideWidth * 2, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); });

    var scrollTimeout;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateArrows, 60);
      },
      { passive: true }
    );
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('.veyron-reels').forEach(initReels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.veyron-reels');
    if (section) initReels(section);
  });
})();
